import { Component } from '@angular/core';

@Component({
  selector: 'app-balance-off',
  templateUrl: './balance-off.component.html',
  styleUrls: ['./balance-off.component.scss']
})
export class BalanceOffComponent {

}
